<div class="ds-shell">

  <!-- ===== SIDEBAR ===== -->
  <aside class="ds-sidebar" [class.ds-sidebar--collapsed]="isDashboardCollapsed()">

    <!-- Brand header (h-14, border-b) -->
    <div class="ds-sidebar__brand">
      <a routerLink="/dashboard" class="ds-brand-link" aria-label="RARR — home">
        <span class="ds-brand-tile">R</span>
        @if (!isDashboardCollapsed()) {
          <span class="ds-brand-text">
            <span class="ds-brand-name">RARR</span>
            <span class="ds-brand-tagline">Platform</span>
          </span>
        }
      </a>
    </div>

    <!-- Search affordance (expanded only, inert visual pill) -->
    @if (!isDashboardCollapsed()) {
      <div class="ds-search-pill" aria-hidden="true">
        <i class="bi bi-search ds-search-icon" aria-hidden="true"></i>
        <span class="ds-search-label">Search…</span>
        <span class="ds-search-kbd">
          <kbd>⌘</kbd><kbd>K</kbd>
        </span>
      </div>
    }

    <!-- Nav scroll area -->
    <nav class="ds-sidebar__nav" aria-label="Main navigation">

      <!-- Home — always visible -->
      <div class="ds-nav-section">
        <a routerLink="/dashboard" routerLinkActive="ds-nav-link--active"
           [routerLinkActiveOptions]="{ exact: true }"
           class="ds-nav-link"
           [title]="isDashboardCollapsed() ? 'Home' : ''">
          <span class="ds-nav-icon-wrap">
            <i class="bi bi-house-door" aria-hidden="true"></i>
          </span>
          @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Home</span> }
        </a>
      </div>

      <!-- ── Sales Group — ForwardingUser or ForwardingAdmin ── -->
      @if (isForwardingUser$ | async) {
        <div class="ds-nav-section">
          @if (!isDashboardCollapsed()) {
            <div class="ds-nav-group-header">Sales</div>
          }

          <a routerLink="forwarding/dashboard" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Forwarding Dashboard' : ''">
            <span class="ds-nav-icon-wrap">
              <i class="bi bi-speedometer2" aria-hidden="true"></i>
            </span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Dashboard</span> }
          </a>

          <a routerLink="forwarding/quotations" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Quotations' : ''">
            <span class="ds-nav-icon-wrap">
              <i class="bi bi-file-earmark-text" aria-hidden="true"></i>
            </span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Quotations</span> }
          </a>

          <a routerLink="forwarding/inquiries" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Inquiries' : ''">
            <span class="ds-nav-icon-wrap">
              <i class="bi bi-inbox" aria-hidden="true"></i>
            </span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Inquiries</span> }
          </a>

          @if (isForwardingAdmin$ | async) {
            <a routerLink="forwarding/quotation-templates" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Quotation Templates' : ''">
              <span class="ds-nav-icon-wrap">
                <i class="bi bi-layout-text-window-reverse" aria-hidden="true"></i>
              </span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Quotation Templates</span> }
            </a>

            <a routerLink="forwarding/charges" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Charges' : ''">
              <span class="ds-nav-icon-wrap">
                <i class="bi bi-receipt" aria-hidden="true"></i>
              </span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Charges</span> }
            </a>

            <a routerLink="forwarding/rates" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Rates' : ''"
               data-testid="sidebar-rates-entry">
              <span class="ds-nav-icon-wrap">
                <i class="bi bi-bar-chart-steps" aria-hidden="true"></i>
              </span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Rates</span> }
            </a>

            <a routerLink="forwarding/markup-config" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Client Markups' : ''">
              <span class="ds-nav-icon-wrap">
                <i class="bi bi-percent" aria-hidden="true"></i>
              </span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Client Markups</span> }
            </a>

            <a routerLink="forwarding/customs-processes" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Customs Brokerage' : ''">
              <span class="ds-nav-icon-wrap">
                <i class="bi bi-file-earmark-check" aria-hidden="true"></i>
              </span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Customs Brokerage</span> }
            </a>
          }
        </div>
      }

      <!-- ── Data Configuration Group — ForwardingAdmin only ── -->
      @if (isForwardingAdmin$ | async) {
        <div class="ds-nav-section">
          @if (!isDashboardCollapsed()) {
            <div class="ds-nav-group-header">Data Configuration</div>
          }

          <a routerLink="forwarding/vendors" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Vendors' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-people" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Vendors</span> }
          </a>

          <a routerLink="forwarding/ports" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Ports' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-pin-map" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Ports</span> }
          </a>

          <a routerLink="forwarding/incoterms" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Incoterms' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-tags" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Incoterms</span> }
          </a>

          <a routerLink="forwarding/container-load-types" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Container Load Types' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-box-seam" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Container Load Types</span> }
          </a>

          <a routerLink="forwarding/unit-bases" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Unit Bases' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-rulers" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Unit Bases</span> }
          </a>

          <!-- Settings sub-label (expanded only) + items always visible -->
          @if (!isDashboardCollapsed()) {
            <div class="ds-nav-sub-label">Settings</div>
          }

          <a routerLink="forwarding/settings/exchange-rates" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Exchange Rates' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-currency-exchange" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Exchange Rates</span> }
          </a>

          <a routerLink="forwarding/settings/charge-basis" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Charge Basis' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-calculator" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Charge Basis</span> }
          </a>

          <a routerLink="forwarding/settings/marine-insurance" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Marine Insurance Config' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-life-preserver" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Marine Insurance Config</span> }
          </a>

          <a routerLink="forwarding/admin" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link ds-nav-link--legacy"
             [title]="isDashboardCollapsed() ? 'Legacy Admin' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-grid-3x3-gap" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Legacy Admin</span> }
          </a>
        </div>
      }

      <!-- ── Shopee Group — Admin, ShopeeDocsTeam, ShopeeChecker ── -->
      @if ((isAdmin$ | async) || (isShopeeDocsTeam$ | async) || (isShopeeChecker$ | async)) {
        <div class="ds-nav-section">
          @if (!isDashboardCollapsed()) {
            <div class="ds-nav-group-header">Shopee</div>
          }

          @if ((isAdmin$ | async) || (isShopeeDocsTeam$ | async)) {
            <a routerLink="shopee" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Shopee Dashboard' : ''">
              <span class="ds-nav-icon-wrap"><i class="bi bi-speedometer2" aria-hidden="true"></i></span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Dashboard</span> }
            </a>

            <a routerLink="orders" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Shopee Orders' : ''">
              <span class="ds-nav-icon-wrap"><i class="bi bi-bag-check" aria-hidden="true"></i></span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Shopee Orders</span> }
            </a>
          }

          @if ((isAdmin$ | async) || (isShopeeDocsTeam$ | async) || (isShopeeChecker$ | async)) {
            <a routerLink="pre-alerts" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Pre-Alerts' : ''">
              <span class="ds-nav-icon-wrap"><i class="bi bi-bell" aria-hidden="true"></i></span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Pre-Alerts</span> }
            </a>
          }

          @if ((isAdmin$ | async) || (isShopeeDocsTeam$ | async)) {
            <a routerLink="manifest" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Manifest' : ''">
              <span class="ds-nav-icon-wrap"><i class="bi bi-file-earmark-spreadsheet" aria-hidden="true"></i></span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Manifest</span> }
            </a>

            <a routerLink="customs-clearance-progress" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Customs Clearance Progress' : ''">
              <span class="ds-nav-icon-wrap"><i class="bi bi-graph-up" aria-hidden="true"></i></span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Customs Clearance Progress</span> }
            </a>
          }

          @if ((isAdmin$ | async) || (isWarehouse$ | async) || (isShopeeChecker$ | async)) {
            <a routerLink="mobile-scanner" routerLinkActive="ds-nav-link--active"
               class="ds-nav-link"
               [title]="isDashboardCollapsed() ? 'Mobile Carton Scanner' : ''">
              <span class="ds-nav-icon-wrap"><i class="bi bi-qr-code-scan" aria-hidden="true"></i></span>
              @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Mobile Carton Scanner</span> }
            </a>
          }
        </div>
      }

      <!-- ── Management Group — Admin only ── -->
      @if (isAdmin$ | async) {
        <div class="ds-nav-section">
          @if (!isDashboardCollapsed()) {
            <div class="ds-nav-group-header">Management</div>
          }

          <a routerLink="user-management" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'User Management' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-people" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">User Management</span> }
          </a>

          <a routerLink="template-management" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'XML Template Management' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-file-code" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">XML Template Management</span> }
          </a>

          <a routerLink="integration-management" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Integration Management' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-link-45deg" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Integration Management</span> }
          </a>

          <a routerLink="system-health" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'System Health' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-heart-pulse" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">System Health</span> }
          </a>

          <a routerLink="security" routerLinkActive="ds-nav-link--active"
             class="ds-nav-link"
             [title]="isDashboardCollapsed() ? 'Security Dashboard' : ''">
            <span class="ds-nav-icon-wrap"><i class="bi bi-shield-check" aria-hidden="true"></i></span>
            @if (!isDashboardCollapsed()) { <span class="ds-nav-label">Security Dashboard</span> }
          </a>
        </div>
      }

    </nav><!-- end ds-sidebar__nav -->

    <!-- Sidebar footer: user + sign-out + collapse -->
    <div class="ds-sidebar__footer">
      <div class="ds-footer-user" [class.ds-footer-user--collapsed]="isDashboardCollapsed()">
        @if (!isDashboardCollapsed()) {
          <!-- Expanded: avatar + name + role (clickable → user-preferences) + sign-out -->
          <div class="ds-footer-identity"
               role="button"
               tabindex="0"
               (click)="navigateToPreferences()"
               (keydown.enter)="navigateToPreferences()"
               (keydown.space)="navigateToPreferences()"
               title="User preferences"
               aria-label="Open user preferences"
               style="cursor: pointer;">
            <span class="ds-avatar" aria-hidden="true">{{ userInitials() }}</span>
            <div class="ds-footer-userinfo">
              <span class="ds-footer-username">{{ displayUsername() || 'User' }}</span>
              <span class="ds-footer-caption">{{ displayRole() || 'User' }}</span>
            </div>
          </div>
          <button type="button"
            class="ds-signout-btn"
            (click)="logout(); $event.stopPropagation()"
            title="Sign out"
            aria-label="Sign out">
            <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
          </button>
        } @else {
          <!-- Collapsed: avatar (clickable → user-preferences) + sign-out stacked -->
          <span class="ds-avatar"
                role="button"
                tabindex="0"
                (click)="navigateToPreferences()"
                (keydown.enter)="navigateToPreferences()"
                (keydown.space)="navigateToPreferences()"
                title="User preferences — {{ displayUsername() || 'User' }}"
                aria-label="Open user preferences"
                style="cursor: pointer;">{{ userInitials() }}</span>
          <button type="button"
            class="ds-signout-btn ds-signout-btn--collapsed"
            (click)="logout(); $event.stopPropagation()"
            title="Sign out"
            aria-label="Sign out">
            <i class="bi bi-box-arrow-right" aria-hidden="true"></i>
          </button>
        }
      </div>

      <!-- Version badge (expanded only) + collapse toggle -->
      <div class="ds-footer-bottom">
        @if (!isDashboardCollapsed()) {
          <button type="button"
            class="ds-version-badge"
            (click)="openVersionModal()"
            [title]="'RARR System v' + appVersion">
            <i class="bi bi-code-square" aria-hidden="true"></i>
            <span>v{{ appVersion }}</span>
          </button>
        }
        <button type="button"
          class="ds-collapse-btn"
          (click)="toggleDashboard()"
          [attr.aria-label]="isDashboardCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'">
          <i [class]="isDashboardCollapsed() ? 'bi bi-panel-right' : 'bi bi-panel-left'" aria-hidden="true"></i>
          @if (!isDashboardCollapsed()) { <span>Collapse</span> }
        </button>
      </div>
    </div>

  </aside>
  <!-- ===== END SIDEBAR ===== -->

  <!-- ===== MAIN AREA (top bar + content) ===== -->
  <div class="ds-main-area">

    <!-- Top bar — h-14, sticky -->
    <header class="ds-topbar">

      <!-- LEFT: Home icon + breadcrumbs -->
      <nav class="ds-breadcrumb" aria-label="Breadcrumb">
        <i class="bi bi-house-door ds-breadcrumb__home-icon" aria-hidden="true"></i>
        @for (crumb of breadcrumbs(); track crumb.path; let last = $last; let first = $first) {
          @if (!first) {
            <i class="bi bi-chevron-right ds-breadcrumb__sep-icon" aria-hidden="true"></i>
          }
          @if (!last) {
            <a [routerLink]="crumb.path" class="ds-breadcrumb__link">{{ crumb.label }}</a>
          } @else {
            <span class="ds-breadcrumb__current" aria-current="page">{{ crumb.label }}</span>
          }
        }
      </nav>

      <!-- RIGHT: search affordance + bell + divider + user pill -->
      <div class="ds-topbar__right">

        <!-- Quick search — visual affordance, hidden on small screens, inert -->
        <button type="button"
          class="ds-topbar-search"
          aria-label="Quick search (coming soon)"
          title="Quick search — coming soon"
          tabindex="-1"
          aria-disabled="true">
          <i class="bi bi-search" aria-hidden="true"></i>
          <span class="ds-topbar-search-label">Quick search</span>
          <span class="ds-topbar-search-kbd">
            <kbd>⌘</kbd><kbd>K</kbd>
          </span>
        </button>

        <!-- Notifications bell — visual affordance only, not yet wired -->
        <button type="button"
          class="ds-topbar-icon-btn"
          aria-label="Notifications (coming soon)"
          tabindex="-1"
          aria-disabled="true">
          <i class="bi bi-bell" aria-hidden="true"></i>
          <span class="ds-notif-dot" aria-hidden="true"></span>
        </button>

        <!-- Divider -->
        <span class="ds-topbar-divider" aria-hidden="true"></span>

        <!-- User avatar pill -->
        <div class="ds-topbar__user">
          <span class="ds-avatar ds-avatar--topbar" aria-hidden="true">{{ userInitials() }}</span>
          <div class="ds-topbar-userinfo">
            @if (displayUsername()) {
              <span class="ds-topbar-username">{{ displayUsername() }}</span>
            }
            <span class="ds-topbar-caption">{{ displayRole() || 'User' }}</span>
          </div>
        </div>

      </div>
    </header>

    <!-- Content area -->
    <main class="ds-content">
      <router-outlet></router-outlet>
    </main>

  </div>
  <!-- ===== END MAIN AREA ===== -->

  <!-- Toast Notifications -->
  <app-toast-notification></app-toast-notification>

  <!-- Version Info Modal -->
  <app-version-info></app-version-info>

</div>
